import Route from '@ember/routing/route'

export default Route.extend()

import deprecated_gjYVqPLMxe from "discourse/lib/deprecated";
deprecated_gjYVqPLMxe(
  "The file 'discourse/routes/siwe-auth-index.js.es6' uses the deprecated `.js.es6` extension. Use `.js` instead.",
  {
    id: "discourse.es6-extension",
    url: "https://meta.discourse.org/t/398894",
  }
);
